<template>
  <div>
    <div
      class="
        relative
        m-auto
        flex flex-col
        items-center
        mt-6
        mb-20
        add-section-wrapper
      "
    >
      <div
        v-if="isElementOptionShow"
        class="
          flex flex-wrap
          absolute
          bg-white
          p-5
          btn-radius
          bottom-0
          shadow-lg
          mb-12
          z-40
          add-section-content
        "
        :class="length < 1 ? 'add-section-bottom' : ''"
        v-on-click-outside="toggleIsElementOptionShow"
      >
        <div class="w-1/4 p-1 cursor-pointer" @click="addNewSection('video')">
          <div
            class="
              w-full
              h-24
              flex flex-col
              justify-center
              items-center
              border border-grey-200
              btn-radius
              p-2
            "
          >
            <div>
              <videoIcon />
            </div>
            <div class="text-xs text-dark mt-4">Video</div>
          </div>
        </div>
        <div class="w-1/4 p-1 cursor-pointer" @click="addNewSection('text')">
          <div
            class="
              w-full
              h-24
              flex flex-col
              justify-center
              items-center
              border border-grey-200
              btn-radius
              p-2
            "
          >
            <div>
              <contentIcon />
            </div>
            <div class="text-xs text-dark mt-4">Content</div>
          </div>
        </div>
        <div
          class="w-1/4 p-1 cursor-pointer"
          @click="addNewSection('checklist')"
        >
          <div
            class="
              w-full
              h-24
              flex flex-col
              justify-center
              items-center
              border border-grey-200
              btn-radius
              p-2
            "
          >
            <div>
              <checklistIcon />
            </div>
            <div class="text-xs text-dark mt-4">Checklist</div>
          </div>
        </div>
        <div
          class="w-1/4 p-1 cursor-pointer"
          @click="addNewSection('accordion')"
        >
          <div
            class="
              w-full
              h-24
              flex flex-col
              justify-center
              items-center
              border border-grey-200
              btn-radius
              p-2
            "
          >
            <div>
              <accordianIcon />
            </div>
            <div class="text-xs text-dark mt-4">Accordion</div>
          </div>
        </div>
        <div class="w-1/4 p-1 cursor-pointer" @click="addNewSection('audio')">
          <div
            class="
              w-full
              h-24
              flex flex-col
              justify-center
              items-center
              border border-grey-200
              btn-radius
              p-2
              relative
              overflow-hidden
            "
          >
            <div>
              <audioIcon />
            </div>
            <div class="text-xs text-dark mt-4">Audio</div>
          </div>
        </div>
        <div
          class="w-1/4 p-1 cursor-pointer"
          @click="addNewSection('download')"
        >
          <div
            class="
              w-full
              h-24
              flex flex-col
              justify-center
              items-center
              border border-grey-200
              btn-radius
              p-2
            "
          >
            <div>
              <downloadIcon />
            </div>
            <div class="text-xs text-dark mt-4">Download</div>
          </div>
        </div>
        <div class="w-1/4 p-1 cursor-pointer" @click="addNewSection('pdf')">
          <div
            class="
              w-full
              h-24
              flex flex-col
              justify-center
              items-center
              border border-grey-200
              btn-radius
              p-2
            "
          >
            <div>
              <downloadIcon />
            </div>
            <div class="text-xs text-dark mt-4">PDF Section</div>
          </div>
        </div>
      </div>
      <div
        class="
          flex
          items-center
          justify-center
          cursor-pointer
          text-3xl
          bg-pink
          w-10
          h-10
          text-white
          font-bold
          rounded
        "
      >
        <span
          :class="isElementOptionShow ? 'transform rotate-45' : ''"
          class="w-full max-w-full text-center"
          @click="toggleIsElementOptionShow"
          >+</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { directive as onClickOutside } from 'vue-on-click-outside';
import videoIcon from '../../../../../assets/images/icons/video.svg';
import contentIcon from '../../../../../assets/images/icons/content.svg';
import checklistIcon from '../../../../../assets/images/icons/checklist.svg';
import accordianIcon from '../../../../../assets/images/icons/accordian.svg';
import audioIcon from '../../../../../assets/images/icons/audio.svg';
import downloadIcon from '../../../../../assets/images/icons/download.svg';
import defaultSectionsHelper from '../defaultSections';

export default {
  name: 'AddSection',
  directives: {
    onClickOutside,
  },
  components: {
    videoIcon,
    contentIcon,
    checklistIcon,
    accordianIcon,
    audioIcon,
    downloadIcon,
  },
  props: {
    callback: {
      required: true,
      type: Function,
    },
    length: {},
  },
  data() {
    return {
      isElementOptionShow: false,
    };
  },
  methods: {
    toggleIsElementOptionShow() {
      this.isElementOptionShow = !this.isElementOptionShow;
    },
    addNewSection(type) {
      this.callback(this.getDefaultContent(type));
      this.toggleIsElementOptionShow();
    },
    getDefaultContent(type) {
      const obj = defaultSectionsHelper();

      if (
        ![
          'video',
          'text',
          'checklist',
          'accordion',
          'audio',
          'download',
          'pdf',
        ].includes(type)
      ) {
        return obj.video;
      }
      return obj[type];
    },
  },
};
</script>
<style>
@media only screen and (min-width: 1500px) {
  .add-section-wrapper {
    padding-bottom: 50px;
  }
}
.add-section-wrapper .add-section-content {
  width: 420px;
}
</style>